import { theme as chakraTheme } from '@chakra-ui/theme';

export const fontSizes = {
  ...chakraTheme.fontSizes,
  md: 20,
  lg: 25,
  xl: 35,
};
